import React, { useState, useEffect, useCallback, useRef } from 'react';
import ContactLaptopSvg from '../../assets/images/contact-laptop.svg'
import { fieldLengths } from '../../Constants/MainKeys';
import ActionButton from '../../Components/Buttons/ActionButton';
import uuid from 'react-uuid';
import ReactSelectOption from '../../Components/SelectOption/ReactSelectOption';
import { useDispatch } from 'react-redux';
import { addButtonSpinner, removeButtonSpinner } from '../../Store/Actions/spinner';
import AlertService from './../../Services/AlertService';
import CloudflareCaptchaComponent from '../../Components/CloudflareCaptchaComponent/CloudflareCaptchaComponent';
import ApiService from '../../Services/ApiService';
import { Link } from 'react-router-dom';

const buttonSpinnerId = uuid();
export default function ContactUs() {

  const businessTypes = [
    {
      id: 1,
      name: "Merchant",
    },
    {
      id: 2,
      name: "Paying Customer",
    },
    {
      id: 3,
      name: "Other",
    },
  ]
  const dispatch = useDispatch();

  const [values, setValues] = useState({
    legalBusinessName: "",
    businessTypeId: null,
    firstName: "",
    lastName: "",
    email: "",
    message: "",
  });

  const resetForm = () => {
    setValues({
      legalBusinessName: "",
      businessTypeId: null,
      firstName: "",
      lastName: "",
      email: "",
      message: "",
    })
  }

  const [isInvalidSubmit, setIsInvalidSubmit] = useState(false);
  const [captchaToken, setCaptchaToken] = useState("");

  useEffect(() => {
    return () => {
      setIsInvalidSubmit(false);
    }
  }, [])

  const onChange = (event, fieldName, maxLength = null) => {
    if (maxLength && maxLength < event.target.value.length) { return; }
    setValues((values) => ({
      ...values,
      [fieldName]: event.target.value,
    }));
    setIsInvalidSubmit(false);
  }

  const onSelectOptionChange = (item, fieldName) => {
    if (!item) { return false; }
    setValues(values => ({
      ...values,
      [fieldName]: item.value
    }))
    setIsInvalidSubmit(false);
  }

  const onSubmit = (event) => {
    event.preventDefault();
    let isInvalid = false;

    const {
      firstName,
      lastName,
      email,
      message,
      businessTypeId,
      legalBusinessName,
    } = values;

    if (!email.trim().length || !message.trim().length || !businessTypeId) {
      isInvalid = true;
    }
    if (businessTypeId === 1 && !values.legalBusinessName.trim().length) {
      isInvalid = true;
    }
    if (businessTypeId === 2 && (!values.firstName.trim().length || !values.lastName.trim().length)) {
      isInvalid = true;
    }
    if (businessTypeId === 3) {
      if ((values.firstName.trim().length && values.lastName.trim().length) || values.legalBusinessName.trim().length) {
      } else {
        isInvalid = true;
      }
    }

    if (isInvalid) {
      setIsInvalidSubmit(true);
      return;
    }

    const form = {
      legalBusinessName,
      businessTypeId,
      firstname: firstName,
      lastName: lastName,
      email,
      message,
      token: captchaToken,
      isClientAnswer: true,
    };
    setButtonSpinner(buttonSpinnerId);
    ApiService.sendContactUsData(form).then(() => {
      AlertService.alert("success", "Thank you! We've received your request. Our support team will follow up with you soon.")
      resetForm();
    }).catch(error => getFail(error)).finally(() => {
      extractButtonSpinner(buttonSpinnerId);
    })

  }

  const getFail = (error) => {
    error && AlertService.alert((AlertService.checkMessageType(error.respcode) || "error"), error);
  };


  const onCheckBusinessNameValidation = () => {
    if (isInvalidSubmit) {
      if (values.businessTypeId === 1 && !values.legalBusinessName.trim().length) {
        return "cx--danger-border"
      }
      if (values.businessTypeId === 3) {
        if (values.legalBusinessName.trim().length) {
          return ""
        } else {
          if (!values.firstName.trim().length && !values.lastName.trim().length) {
            return "cx--danger-border"
          }
        }
      }

    }
    return ""
  }

  const onCheckFirstNameValidation = () => {
    if (isInvalidSubmit) {
      if (values.businessTypeId === 2 && !values.firstName.trim().length) {
        return "cx--danger-border"
      }
      if (values.businessTypeId === 3) {
        if (!values.firstName.trim().length && values.lastName.trim().length) {
          return "cx--danger-border"
        }
        if (!values.firstName.trim().length && !values.lastName.trim().length && values.legalBusinessName.trim().length) {
          return ""
        }
        if (!values.lastName.trim().length && !values.firstName.trim().length && !values.legalBusinessName.trim().length) {
          return "cx--danger-border"
        }
      }
    }
    return ""
  }

  const onCheckLastNameValidation = () => {
    if (isInvalidSubmit) {
      if (values.businessTypeId === 2 && !values.lastName.trim().length) {
        return "cx--danger-border"
      }
      if (values.businessTypeId === 3) {
        if (!values.lastName.trim().length && values.firstName.trim().length) {
          return "cx--danger-border"
        }
        if (!values.lastName.trim().length && !values.firstName.trim().length && values.legalBusinessName.trim().length) {
          return ""
        }
        if (!values.lastName.trim().length && !values.firstName.trim().length && !values.legalBusinessName.trim().length) {
          return "cx--danger-border"
        }
      }
    }
    return ""
  }

  const setButtonSpinner = useCallback(spinner => {
    dispatch(addButtonSpinner(spinner));
  }, []);

  const extractButtonSpinner = useCallback(spinner => {
    dispatch(removeButtonSpinner(spinner));
  }, []);

  return <div className="row">
    <div className="col-lg-6 mt-5">
      <form onSubmit={onSubmit}>
        <div className="row">
          <div className="col-lg-6">
            <div className="cx--form-control">
              <input
                type="text"
                name="legalBusinessName"
                placeholder={`Legal Business Name`}
                value={values.legalBusinessName}
                className={onCheckBusinessNameValidation()}
                onChange={event => onChange(event, "legalBusinessName", fieldLengths.length_120)}
              />
              <span>Legal Business Name</span>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="cx--form-control">
              <ReactSelectOption
                value={values.businessTypeId}
                isInvalidSubmit={isInvalidSubmit}
                selectedValue={(() => {
                  const selectedValue = { ...businessTypes.find(data => data.id === values.businessTypeId) };
                  if (Object.keys(selectedValue).length) {
                    selectedValue.label = selectedValue.name;
                    selectedValue.value = selectedValue.id;
                    return selectedValue;
                  } else {
                    return { label: "Customer Type", value: null }
                  }
                })()}
                className="custom-select"
                items={businessTypes.map(data => ({ label: data.name, value: data.id }))}
                onChange={(item) => onSelectOptionChange(item, "customerType")}
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="cx--form-control">
              <input
                type="text"
                name="firstName"
                placeholder='First name'
                value={values.firstName}
                className={onCheckFirstNameValidation("firstName")}
                onChange={event => onChange(event, "firstName", fieldLengths.length_120)}
              />
              <span>First name</span>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="cx--form-control">
              <input
                type="text"
                name="lastName"
                placeholder='Last name'
                value={values.lastName}
                className={onCheckLastNameValidation("lastName")}
                onChange={event => onChange(event, "lastName", fieldLengths.length_120)}
              />
              <span>Last name</span>
            </div>
          </div>
          <div className="col-12">
            <div className="cx--form-control">
              <input
                type="email"
                name="email"
                placeholder='E-mail'
                value={values.email}
                className={`${(isInvalidSubmit && !values.email.trim().length) ? "cx--danger-border" : ""}`}
                onChange={event => onChange(event, "email", fieldLengths.length_120)}
              />
              <span>E-mail</span>
            </div>
          </div>
          <div className="col-12">
            <div className="cx--form-control mb-2">
              <textarea
                placeholder="Hi Dear Cryllex team..."
                name="message"
                rows="4"
                style={{ resize: "none" }}
                value={values.message}
                className={`${(isInvalidSubmit && !values.message.trim().length) ? "cx--danger-border" : ""}`}
                onChange={event => onChange(event, "message", fieldLengths.length_2000)}
              />
              <span>Type message...</span>
            </div>
          </div>
          <div className="col-12 mb-2">
            <CloudflareCaptchaComponent cb={setCaptchaToken} />
          </div>

          <div className="col-12">
            <ActionButton
              name="Submit"
              type="submit"
              className={`cx--btn cx--btn-primary px-5 w-100 ${!captchaToken ? "disabled" : ""}`}
              disabled={!captchaToken}
              spinnerId={buttonSpinnerId}
            />
          </div>
        </div>
      </form>
    </div>
    <div className="col-lg-6 d-lg-block d-none px-5  mt-5">
      <p>We're here to resolve any issues and answer any questions you may have.
        Feel free to also check <Link to="/faq" target='_blank'>Cryllex's FAQ</Link> page for insights that others have frequently requested!</p>
      <p>Submit the Customer Support Ticket and a representative will get back to you shortly.</p>
      <div className='text-center '>
        <img className="cx--aside-image" src={ContactLaptopSvg} alt="contact-us" />
      </div>
    </div>
  </div>
}
